import { combineReducers } from "@reduxjs/toolkit";
import appNoticeReducer from "./appNoticeSlice";
import dashboardReducer from "./dashboardSlice";
import disabledUsersReducer from "./disabledUsersSlice";
import doctorAdminReducer from "./doctorAdminSlice";
import doctorInvitationReducer from "./doctorInvitationSlice";
import errorReducer from "./errorSlice";
import facilityReducer from "./facilitySlice";
import faqReducer from "./faqSlice";
import featureFlagReducer from "./featureFlagSlice";
import managersReducer from "./managersSlice";
import notificationReducer from "./notificationSlice";
import sessionReducer from "./sessionSlice";
import specialtyReducer from "./specialtySlice";
import staticDoctorProfileReducer from "./staticDoctorProfileSlice";
import unverifiedUsersReducer from "./unverifiedUsersSlice";

export const rootReducer = combineReducers({
  session: sessionReducer,
  dashboard: dashboardReducer,
  managers: managersReducer,
  facilities: facilityReducer,
  faqs: faqReducer,
  specialties: specialtyReducer,
  disabledUsers: disabledUsersReducer,
  unverifiedUsers: unverifiedUsersReducer,
  doctorInvitations: doctorInvitationReducer,
  doctorAdmin: doctorAdminReducer,
  staticDoctorProfiles: staticDoctorProfileReducer,
  appNotices: appNoticeReducer,
  featureFlags: featureFlagReducer,
  notifications: notificationReducer,
  globalError: errorReducer,
});
